module.exports = __webpack_public_path__ + "static/media/snakeGameImg.78641c8f.png";